import { Button } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { DeleteGroupTerminalsPermissionsProps } from './DeleteGroupTerminalsPermissions.types';

export const DeleteGroupTerminalsPermissions = ({
  checkedPermissions,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: DeleteGroupTerminalsPermissionsProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        startIcon={<TrashIcon style={{ opacity: !perms?.UPR_GRUPOWE?.edit ? 0.4 : 1 }} />}
        onClick={onModalOpen}
        disabled={!perms?.UPR_GRUPOWE?.edit}
      >
        {formatMessage({ id: AppMessages['group.reader.permissions.multiAction.delete.button'] })}
      </Button>

      <ActionModal
        header={formatMessage({ id: AppMessages['group.reader.permissions.multiAction.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['group.reader.permissions.multiAction.delete.button'] })}
      >
        <>
          <ActionModal.Subtitle>
            {formatMessage({ id: AppMessages['group.reader.permissions.multiAction.delete.subtitle'] })}{' '}
            {checkedPermissions.length}
          </ActionModal.Subtitle>

          <ActionModal.Text>
            {formatMessage({ id: AppMessages['group.reader.permissions.multiAction.delete.text'] })}
          </ActionModal.Text>

          <ActionModal.Text>{formatMessage({ id: AppMessages['common.irreversibleAction'] })}</ActionModal.Text>
        </>
      </ActionModal>
    </>
  );
};
